module.exports = __webpack_public_path__ + "static/media/a-mexican-dinner-party.9b967b9c.jpg";